// extracted by css-extract-rspack-plugin
export default {"modalFooter":"modal-footer_RFeFY","modalGrid":"modal-grid_sEiZj","content":"content_NYRXS","splitter":"splitter_t5yLH","ml5":"ml5_J0JSa","basicContainer":"basic-container_ATPbt"};